// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__1bYTR","input":"Title_input__1Mj7b","moreBtn":"Title_moreBtn__2N8pk"};